const ON_GATES = { tenantPush: 'on', tenantType: 'on', category: 'on', device: 'on' };
export const fixtureGates = [
    { type: 'work_assigned', label: 'Work assigned', gates: ON_GATES, result: 'sends', blockingGate: null },
    {
        type: 'ia_items_to_review',
        label: 'Inspection Assistant: items to review',
        gates: Object.assign(Object.assign({}, ON_GATES), { category: 'off' }),
        result: 'blocked',
        blockingGate: 'category'
    },
    { type: 'activity_note', label: 'New note at a building', gates: ON_GATES, result: 'sends', blockingGate: null }
];
export const linkedRow = {
    id: 'events-101',
    kind: 'both',
    pushType: 'work_assigned',
    typeLabel: 'Work assigned',
    at: '2026-10-15T18:14:16Z',
    railsOutcome: 'published',
    suppressedReason: null,
    sendsAt: null,
    kindCounts: { added: 2, time_changed: 1 },
    subjects: ['Acme Tower', 'Harbor Point Plaza'],
    notificationId: '8841',
    platform: {
        status: 'dispatched',
        failureReason: null,
        title: 'You have 3 updates to your schedule',
        createdAt: '2026-10-15T18:14:16Z',
        dispatchedAt: '2026-10-15T18:14:17Z',
        confirmedAt: '2026-10-15T18:14:19Z',
        replayCount: 0
    },
    events: [
        {
            id: 101,
            kind: 'added',
            buildingName: 'Acme Tower',
            subject: 'Visit #88190',
            scheduledFor: '2026-10-16T13:00:00Z',
            previousScheduledFor: null,
            occurredAt: '2026-10-15T18:12:40Z',
            payload: { building_name: 'Acme Tower', notification_id: '8841' }
        },
        {
            id: 102,
            kind: 'added',
            buildingName: 'Acme Tower',
            subject: 'Visit #88191',
            scheduledFor: '2026-10-16T17:00:00Z',
            previousScheduledFor: null,
            occurredAt: '2026-10-15T18:12:41Z',
            payload: { building_name: 'Acme Tower', notification_id: '8841' }
        },
        {
            id: 103,
            kind: 'time_changed',
            buildingName: 'Harbor Point Plaza',
            subject: 'Visit #87702',
            scheduledFor: '2026-10-18T14:30:00Z',
            previousScheduledFor: '2026-10-17T14:30:00Z',
            occurredAt: '2026-10-15T18:13:15Z',
            payload: { building_name: 'Harbor Point Plaza', notification_id: '8841' }
        }
    ]
};
export const suppressedRow = {
    id: 'events-90',
    kind: 'rails_only',
    pushType: 'work_assigned',
    typeLabel: 'Work assigned',
    at: '2026-10-15T15:01:22Z',
    railsOutcome: 'suppressed',
    suppressedReason: 'netted_out',
    sendsAt: null,
    kindCounts: { added: 1, removed: 1 },
    subjects: ['Riverside Medical Center'],
    notificationId: null,
    platform: null,
    events: [
        {
            id: 90,
            kind: 'added',
            buildingName: 'Riverside Medical Center',
            subject: 'Visit #88004',
            scheduledFor: '2026-10-20T11:30:00Z',
            previousScheduledFor: null,
            occurredAt: '2026-10-15T15:00:51Z',
            payload: { building_name: 'Riverside Medical Center', suppressed: 'netted_out' }
        },
        {
            id: 91,
            kind: 'removed',
            buildingName: 'Riverside Medical Center',
            subject: 'Visit #88004',
            scheduledFor: '2026-10-20T11:30:00Z',
            previousScheduledFor: null,
            occurredAt: '2026-10-15T15:01:22Z',
            payload: { building_name: 'Riverside Medical Center', suppressed: 'netted_out' }
        }
    ]
};
export const platformOnlyRow = {
    id: 'platform-7001',
    kind: 'platform_only',
    pushType: 'test',
    typeLabel: 'Test notification',
    at: '2026-10-14T14:20:44Z',
    railsOutcome: null,
    suppressedReason: null,
    sendsAt: null,
    kindCounts: {},
    subjects: [],
    notificationId: '7001',
    platform: {
        status: 'failed',
        failureReason: 'BadDeviceToken',
        title: 'Test notification from InspectPoint',
        createdAt: '2026-10-14T14:20:44Z',
        dispatchedAt: null,
        confirmedAt: null,
        replayCount: 0
    },
    events: []
};
function dispatchedRow(eventId, notificationId, at, receipt) {
    return {
        id: `events-${eventId}`,
        kind: 'both',
        pushType: 'work_assigned',
        typeLabel: 'Work assigned',
        at,
        railsOutcome: 'published',
        suppressedReason: null,
        sendsAt: null,
        kindCounts: { added: 1 },
        subjects: ['Lakeside Commons'],
        notificationId,
        platform: Object.assign({ status: 'dispatched', failureReason: null, title: 'New job today', createdAt: at, dispatchedAt: at }, receipt),
        events: [
            {
                id: eventId,
                kind: 'added',
                buildingName: 'Lakeside Commons',
                subject: `Visit #${88100 + eventId}`,
                scheduledFor: '2026-10-15T20:00:00Z',
                previousScheduledFor: null,
                occurredAt: at,
                payload: { building_name: 'Lakeside Commons', notification_id: notificationId }
            }
        ]
    };
}
export const unconfirmedRow = dispatchedRow(99, '8840', '2026-10-15T17:30:05Z', { confirmedAt: null, replayCount: 1 });
export const confirmedAfterReplayRow = dispatchedRow(98, '8839', '2026-10-15T17:02:10Z', {
    confirmedAt: '2026-10-15T17:41:55Z',
    replayCount: 2
});
export const replayCappedRow = dispatchedRow(97, '8838', '2026-10-15T16:20:00Z', { confirmedAt: null, replayCount: 3 });
export const fixtureProps = {
    technicianName: 'Dana Whitfield',
    timeZone: 'America/New_York',
    since: '2026-10-02T16:00:00Z',
    capped: false,
    platform: { unavailable: false, health: 'Reachable — the device read on this page reached it.', error: null },
    device: {
        state: 'registered',
        deviceModel: 'iPhone16,2',
        registeredAt: '2026-10-02T13:00:00Z',
        notificationsOn: true
    },
    gates: fixtureGates,
    rows: [linkedRow, unconfirmedRow, confirmedAfterReplayRow, replayCappedRow, suppressedRow, platformOnlyRow]
};
